import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

import { useUserProjectRole } from 'portal/lib/hooks'
import { recordAlertsLoad } from 'portal/store/recordAlerts/actions'

export const useRecordAlertsLoader = (startDate, endDate) => {
  const dispatch = useDispatch()
  const { accountId, projectId } = useParams<{
    accountId: string
    projectId: string
  }>()

  const filter = useMemo(
    () => ({
      startDate,
      endDate
    }),
    [startDate, endDate]
  )

  const { isProjectAdmin } = useUserProjectRole(accountId, projectId)

  const reload = useCallback(() => {
    if (!accountId || !projectId) {
      return
    }
    dispatch(recordAlertsLoad(accountId, projectId, filter))
  }, [accountId, projectId, dispatch, filter])

  useEffect(() => {
    reload()
  }, [reload])

  const { loading, error, items } = useSelector((state: any) => {
    return state.recordAlerts
  })

  return {
    loading,
    error,
    items,
    reload,
    readOnly: !isProjectAdmin
  }
}
